module.exports = __webpack_public_path__ + "static/media/brand.ac8dae78.png";